export const NUMBERS = {
  NINETY: 90,
  ONEHUNDRED: 100
};
